export default __webpack_public_path__ + "static/media/icon-filial.48bab5ec.svg";